import useSWR, { mutate } from "swr";
import Auth from "../Auth";

const useMyVoiceSelectedSample = () => {
  const fetcher = (url) => Auth.fetchWithIdToken(url);

  const endpointURL = "/api/my_voice/selected_style_sample";
  const {
    data: selectedSampleData,
    error,
    isLoading,
    isValidating,
    mutate: mutateSelected,
  } = useSWR(endpointURL, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  const selectedSample = selectedSampleData?.selectedSample || null;
  const selectedStyleSampleId = selectedSampleData?.selectedStyleSampleId || null;

  const setSelectedSample = async (sampleId) => {
    try {
      const response = await Auth.fetchWithIdToken("/api/my_voice/set_selected_style_sample", {
        sample_id: sampleId,
      });

      // Update the cache optimistically
      await mutate(endpointURL);

      return response;
    } catch (error) {
      console.error("Error setting selected style sample:", error);
      throw error;
    }
  };

  const refetchSelectedSample = async () => {
    await mutate(endpointURL);
  };

  return {
    selectedSample,
    selectedStyleSampleId,
    setSelectedSample,
    refetchSelectedSample,
    mutateSelected,
    error,
    isLoading,
    isValidating,
  };
};

export default useMyVoiceSelectedSample;
